export const server =process.env.REACT_APP_SERVER_URL;